import { RootState } from "redux/store";

export function getAllReceipts(state: RootState) {
    return state !== null && state.root.receiptsList
}